module.exports = __webpack_public_path__ + "static/img/KW.0ad52a77.svg";